import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  to: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  withArrow?: boolean;
}
export function Button({
  to,
  children,
  variant = 'primary',
  withArrow = false
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-600 rounded-sm transition-colors';
  const styles = variant === 'primary' ? 'bg-ink text-paper hover:bg-trust-700' : 'bg-transparent text-ink border border-stone-300 hover:border-ink';
  return <Link to={to} className={`${base} ${styles}`} data-id="element-35">
      {children}
      {withArrow && <ArrowRightIcon className="h-4 w-4" data-id="element-36" />}
    </Link>;
}